import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import map from 'lodash/map';

/**
 * @param {string|number|object} size
 * @returns {[string]}
 */
const classes = size => {
    if (typeof size === 'number' || typeof size === 'string') {
        return classes({s: size});
    }

    return map(size, (size, cls) => `${cls}${size}`);
};

/**
 * A convenient column component for wrapping a materialize column.
 *
 * @param {array} children
 * @param {string} [className]
 * @param {string|number} [size]
 * @param {object} [props]
 * @constructor
 */
const Column = ({children, className, size, ...props}) => (
    <div {...props} className={classNames('col', classes(size), className)}>
        {children}
    </div>
);

Column.defaultProps = {
    className: null,
};

Column.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({
            s: PropTypes.number,
            m: PropTypes.number,
            l: PropTypes.number,
            xl: PropTypes.number,
        }),
    ]),
};

/**
 * The default column size is 12.
 */
Column.defaultProps = {
    children: null,
    size: 12,
};

export default Column;



// WEBPACK FOOTER //
// ./scripts/components/Column.js